export default "__VITE_ASSET__BCe9Fjm5__"